import React from "react";
import ReactDOM from "react-dom";
import { getAdhesionRateData } from "../../../infrastructure/repository/reports-repository";
import { findCompanyId } from "../../../infrastructure/repository/company-repository";
import { translate } from "../../../infrastructure/translate/localization";
import { showErrorMessage } from "../../commons/show-error-message";
import { getBlockProps } from "../components/AnalyticsPage/utils";
import AdhesionBlock from "../components/AnalyticsPage/components/AdhesionBlock";

export function renderAdhesionBlock(props) {
  ReactDOM.render(
    <AdhesionBlock {...props} />,
    document.getElementById("adhesion-block")
  );
}

export async function displayAdhesionBlock() {
  renderAdhesionBlock({ isLoading: true });

  const companyId = await findCompanyId();
  try {
    const { data } = await getAdhesionRateData({ companyId });
    renderAdhesionBlock({
      adhesionRateData: data,
      adhesionData: getBlockProps({
        data,
        property: "y",
        formatFunction: (value) => `${value}%`,
        addMonths: 1,
      }),
      loadedEmployeesData: getBlockProps({
        data,
        property: "loadedEmployees",
        addMonths: 1,
      }),
      activeEmployeesData: getBlockProps({
        data,
        property: "activeEmployees",
        addMonths: 1,
      }),
    });
  } catch (e) {
    showErrorMessage(translate("common-messages.basic-error-message"));
  }
}
